import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  variant?: 'dark' | 'light';
  className?: string;
}
export function Breadcrumbs({
  items,
  variant = 'dark',
  className = ''
}: BreadcrumbsProps) {
  const separatorColor = variant === 'light' ? 'text-white/30' : 'text-robeta-black/30';
  const linkColor = variant === 'light' ? 'text-white/50 hover:text-white transition-colors font-medium' : 'text-robeta-black/50 hover:text-robeta-copper transition-colors font-medium';
  const activeColor = variant === 'light' ? 'text-robeta-copper font-bold' : 'text-robeta-copper font-bold';
  return <nav className={`flex items-center text-xs uppercase tracking-widest ${className}`} data-id="element-38">
      {items.map((item, index) => {
      const isLast = index === items.length - 1;
      return <Fragment key={index} data-id="element-39">
            {index > 0 && <ChevronRight className={`w-3 h-3 mx-2 ${separatorColor}`} data-id="element-40" />}
            {item.href && !isLast ? <Link to={item.href} className={linkColor} data-id="element-41">
                {item.label}
              </Link> : <span className={activeColor} data-id="element-42">{item.label}</span>}
          </Fragment>;
    })}
    </nav>;
}